export const GENDER = {
  MALE: "ชาย",
  FEMALE: "หญิง",
  OTHERS: "อื่น ๆ",
};
